import AppRoutes from './routes/AppRoutes';
import GlobalSeoSchemas from './components/seo/GlobalSeoSchemas';

const App = () => (
  <>
    <GlobalSeoSchemas />
    <AppRoutes />
  </>
);

export default App;
